import React from 'react'
import PropTypes from 'prop-types'
import './ProductDetailDisplayName.css'

const ProductDetailDisplayName = ({ children }) => (<h1 className="product-detail-display-name">{children}</h1>)

ProductDetailDisplayName.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ProductDetailDisplayName
